import React, { useEffect, useState } from 'react'
import {
    Breadcrumb,
    Button,
    Card,
    Col,
    Container,
    Form,
    InputGroup,
    Modal,
    Row,
    Table,
} from 'react-bootstrap'
import './style.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch'
import { Formik } from 'formik';
import View from 'asset/SvgComponent/View'
import Delete from 'asset/SvgComponent/Delete'
import EditIcon from 'asset/SvgComponent/EditIcon'
import Pagination from 'components/Pagination'
import Loader from 'components/Loader'
import Alert from 'components/Alert'
import Dialog from 'components/Dialog'
import axios from 'api/index'
import { IAPI_Response } from 'api/types'
import {
    API_ENDPOINT,
    SUCCESS_MESSAGE,
    ERROR_MESSAGE,
    TEXT, IMAGE_BASE_URL
} from 'utils/globalConstant'
import {IAlarmLog, IList, IMachine, IScreenshot, IUserAccount} from "./types";
import moment from "moment/moment";
import Select from "components/ReactSelect";
import {IEmployee} from "../../../Attendance/AttendanceReport/Retail/types";
import Calendar from "asset/SvgComponent/Calendar";
import {validationSchema2} from "../../../Attendance/AttendanceReport/Retail/validationSchema";
import AlarmLogScreenshots from "./AlarmLogScreenshots";

export default function Index() {
    const [searched, setSearched] = React.useState("")
    const [entries, setEntries] = React.useState(10)

    const [currentPage, setCurrentPage] = React.useState(0)
    const [lastPage, setLastPage] = React.useState(0)
    const [itemsPerPage, setPerPage] = React.useState(10)
    const [itemsCount, setItemCount] = React.useState(0)
    const [from, setFrom] = React.useState(0)

    const [error, setError] = React.useState('')
    const [success, setSuccess] = React.useState('')
    const [showError, setShowError] = React.useState(false)
    const [showSuccess, setShowSuccess] = React.useState(false)
    const [showLoading, setShowLoading] = React.useState(false)
    const [showScreenshotPage, setShowScreenshotPage] = React.useState(false)

    const [showScreenshots, setShowScreenshots] = React.useState(false)
    const handleCloseScreenshots = () => {
        setShowScreenshots(false)
    }
    const handleShowScreenshots = () => setShowScreenshots(true)
    const [screenshots, setScreenshots] = React.useState<IScreenshot[]>([])
    const [details, setDetails] = React.useState({
        userAccount: "",
        pcName: "",
        alarm: ""
    })

    const [data, setData] = React.useState<IList[]>([])
    const [employeeOptions, setEmployeeOptions] = useState<{value: number, label: string}[]>([]);
    const [selectedEmployeeOption, setSelectedEmployeeOption] = useState<{value: number, label: string}>({value: 0, label: "All Employees"})
    const [machine, setMachine] = useState({
        id: 0,
        pc_name: "",
        machine_uiid: ""
    })
    const [selectedOption, setSelectedOption] = useState<{value: number, label: string}>({value: 0, label: "All Options"})
    const [options, setOptions] = useState<{value: number, label: string}[]>([])
    const [filter, setFilter] = useState({date_from: "", date_to: "", filter: "user_account"})

    const handleChangeOptionDropdown = (e: any) => {
        setSelectedOption(e)
    }

    const showAlarmScreenshots = (screenshots: any) => {
        setScreenshots(screenshots)
        handleShowScreenshots()
    }

    const handleDisplayDuration = (duration: number) => {
        if(duration < 60){
            return `${duration} secs`
        }else{
            return `${(duration/60).toFixed(1)} min/s`
        }
    }

    const filterAlarmLog = (values: any) => {
        getAlarmLog(null, searched, 10, values.date_from, values.date_to, values.filter)
        setFilter({date_from: values.date_from, date_to: values.date_to, filter: values.filter})
    }

    const getAlarmLog = async (page_number: null | number, searched: string, entries: number, date_from: string, date_to: string, filter: string) => {
        setShowLoading(true)
        try {
            const response = await axios.get<IAPI_Response<IAlarmLog>>(API_ENDPOINT.GET_ALARM_LOGS, {
                params: {
                    page: page_number,
                    searched: searched,
                    entries: entries,
                    date_from: date_from,
                    date_to: date_to,
                    filter: filter,
                    option: selectedOption.value
                },
            })
            const result = await response
            console.log(result?.data?.results?.data)
            if (result?.data?.results?.data?.length) {
                setData(result?.data?.results?.data)
                setCurrentPage(result?.data?.results?.current_page)
                setLastPage(result?.data?.results?.last_page)
                setPerPage(result?.data?.results?.per_page)
                setItemCount(result?.data?.results?.total)
                setFrom(result?.data?.results?.from)
            }else{
                setData([])
            }
            setShowLoading(false)
        } catch {
            setShowError(true)
            setError(ERROR_MESSAGE.SYSTEM_ERROR)
        }

        setTimeout(() => {
            setShowError(false)
        }, 3000);
    }


    const getAllUserAccounts = async () => {
        try {
            const res = await axios.get<IAPI_Response<IUserAccount[]>>(API_ENDPOINT.GET_ALL_USER_ACCOUNTS)
            const result = await res
            if (result?.data?.results?.length) {
                const user_accounts = result?.data?.results;
                setOptions([])
                setOptions(current => [...current, {value: 0, label: "All Options"}]);
                user_accounts.map(user => {
                    setOptions(current => [...current, {value: user.id, label: user.username}]);
                })

            }
        } catch {
            console.log('There is something wrong')
        }
    }

    const getAllMachines = async () => {
        try {
            const res = await axios.get<IAPI_Response<IMachine[]>>(API_ENDPOINT.GET_ALL_MACHINES)
            const result = await res
            if (result?.data?.results?.length) {
                const machines = result?.data?.results;
                setOptions([])
                setOptions(current => [...current, {value: 0, label: "All Options"}]);
                machines.map(machine => {
                    setOptions(current => [...current, {value: machine.id, label: machine.pc_name}]);
                })

            }
        } catch {
            console.log('There is something wrong')
        }
    }

    useEffect(() => {
        ;(async () => {
            getAlarmLog(null, searched, entries, filter.date_from, filter.date_to, filter.filter)
            await getAllUserAccounts()
        })()
    }, [])

    return (
        <>
            <Container fluid>
                <h5 className='fw-bold'>Alarm Logs</h5>
                <Breadcrumb className='breadcrumbs'>
                    <Breadcrumb.Item className=' text-decoration-none' href='#'>
                        Home
                    </Breadcrumb.Item>
                    <Breadcrumb.Item className=' text-decoration-none' href='#'>
                        Monitoring
                    </Breadcrumb.Item>
                    <Breadcrumb.Item className=' text-decoration-none' href='#'>
                        Alarms
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>Alarm Log</Breadcrumb.Item>
                </Breadcrumb>

                <Alert
                    type="success"
                    show={showSuccess}
                    message={success}
                    setShow={() => {
                        setShowSuccess(false);
                    }
                    }
                />

                <Alert
                    type="error"
                    show={showError}
                    message={error}
                    setShow={() => {
                        setShowError(false);
                    }
                    }
                />
                <Card className='border-0  p-0 bordered-card'>
                    <Card.Body>
                        {
                            !showScreenshotPage ?
                                <>
                                    <Row>
                                        <Col sm={12}>
                                            <Formik
                                                initialValues={
                                                    {
                                                        date_from: "",
                                                        date_to: "",
                                                        filter: 'user_account',
                                                        option: 0
                                                    }
                                                }
                                                // validationSchema={validationSchema2}
                                                onSubmit={filterAlarmLog}
                                            >
                                                {({
                                                      values,
                                                      errors,
                                                      touched,
                                                      handleChange,
                                                      handleBlur,
                                                      handleSubmit,
                                                      isSubmitting
                                                  }) => (

                                                    <Form noValidate onSubmit={handleSubmit}>
                                                        <Row>
                                                            <Col sm={2}>
                                                                <Form.Group className='mb-3' controlId='formHorizontalEmail'>
                                                                    <Form.Label className='fw-bold form-labels'>Date From</Form.Label>
                                                                    <InputGroup className='mb-2 ' size={'sm'}>
                                                                        <InputGroup.Text id='basic-addon1' className='text-muted fw-bold bg-white'>
                                                                            <Calendar/>
                                                                        </InputGroup.Text>
                                                                        <Form.Control
                                                                            size={'sm'}
                                                                            type='date'
                                                                            placeholder='Friday, June 03, 2022'
                                                                            name='date_from'
                                                                            value={values.date_from}
                                                                            onChange={(e: any) => {
                                                                                handleChange(e);
                                                                                handleSubmit();
                                                                                // setDateFilter(e.target.value)
                                                                            }}
                                                                            onBlur={handleBlur}
                                                                            isInvalid={touched.date_from && !!errors.date_from}
                                                                            max={moment().format("YYYY-MM-DD")}
                                                                        />
                                                                        <Form.Control.Feedback type="invalid">
                                                                            {errors.date_from}
                                                                        </Form.Control.Feedback>
                                                                    </InputGroup>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col sm={2}>
                                                                <Form.Group className='mb-3' controlId='formHorizontalEmail'>
                                                                    <Form.Label className='fw-bold form-labels'>Date To</Form.Label>
                                                                    <InputGroup className='mb-2 ' size={'sm'}>
                                                                        <InputGroup.Text id='basic-addon1' className='text-muted fw-bold bg-white'>
                                                                            <Calendar/>
                                                                        </InputGroup.Text>
                                                                        <Form.Control
                                                                            size={'sm'}
                                                                            type='date'
                                                                            placeholder='Friday, June 03, 2022'
                                                                            name='date_to'
                                                                            value={values.date_to}
                                                                            onChange={(e: any) => {
                                                                                handleChange(e);
                                                                                handleSubmit();
                                                                                // setDateFilter(e.target.value)
                                                                            }}
                                                                            onBlur={handleBlur}
                                                                            isInvalid={touched.date_to && !!errors.date_to}
                                                                            max={moment().format("YYYY-MM-DD")}
                                                                        />
                                                                        <Form.Control.Feedback type="invalid">
                                                                            {errors.date_to}
                                                                        </Form.Control.Feedback>
                                                                    </InputGroup>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col sm={2}>
                                                                <Form.Group className='mb-3' controlId='formHorizontalEmail'>
                                                                    <Form.Label className='fw-bold form-labels'>Filter By</Form.Label>
                                                                    <Form.Select
                                                                        size={'sm'}
                                                                        name="filter"
                                                                        value={values.filter}
                                                                        onChange={async (e: any) => {
                                                                            handleChange(e);
                                                                            if(e.target.value == "user_account"){
                                                                                await getAllUserAccounts()
                                                                            }else if(e.target.value == "pc_name"){
                                                                                await getAllMachines()
                                                                            }
                                                                            setSelectedOption({value: 0, label: "All Options"})
                                                                            handleSubmit();
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                        isInvalid={touched.filter && !!errors.filter}
                                                                    >
                                                                        <option value="user_account">User Account</option>
                                                                        <option value="pc_name">PC Name</option>

                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col sm={2}>
                                                                <Form.Group className='mb-3' controlId='formHorizontalEmail'>
                                                                    <Form.Label className='fw-bold form-labels'>Options</Form.Label>
                                                                    <Select
                                                                        name="option"
                                                                        value={selectedOption}
                                                                        options={options}
                                                                        onChange={(e: any) => {
                                                                            handleChangeOptionDropdown(e)
                                                                            // handleChange(e)
                                                                            handleSubmit()
                                                                        }}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col sm={4} className='d-flex justify-content-end hidden' style={{height: '30px', margin: 'auto 0 auto 0'}}>
                                                                <InputGroup size='sm' className={'w-50'}>
                                                                    <Form.Control
                                                                        aria-label='search'
                                                                        aria-describedby='inputGroup-sizing-sm'
                                                                        placeholder='Search...'
                                                                    />
                                                                    <InputGroup.Text className='bg-transparent search-input '>
                                                                        <FontAwesomeIcon icon={faSearch} />
                                                                    </InputGroup.Text>
                                                                </InputGroup>
                                                            </Col>
                                                        </Row>
                                                    </Form>

                                                )}
                                            </Formik>
                                        </Col>
                                    </Row>

                                    <Table responsive className='bordered-tabs-top mt-3'>
                                        <thead>
                                        <tr>
                                            <th style={{ width: '5%' }} className='text-center'>
                                                No.
                                            </th>
                                            <th style={{ width: '18%' }} className='text-center'>
                                                User Account
                                            </th>
                                            <th style={{ width: '13%' }} className='text-center'>
                                                PC Name
                                            </th>
                                            <th style={{ width: '15%' }} className='text-center'>
                                                Alarm Name
                                            </th>
                                            <th style={{ width: '18%' }} className='text-center'>
                                                Duration
                                            </th>
                                            <th style={{ width: '15%' }} className='text-center'>
                                                Website
                                            </th>
                                            <th className='text-center'>
                                                Date
                                            </th>
                                            <th className='text-center'>
                                                Actions
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <>
                                            {data.length > 0 ? (
                                                data.map((item, index) =>
                                                    <tr className='mb-2 reduce-font' key={index}>
                                                        <td className={'text-center'}>{from + index}</td>
                                                        <td>{item.username}</td>
                                                        <td>{item.pc_name}</td>
                                                        <td>{item.name}</td>
                                                        <td className={'text-center'}>{moment(item.date_start).format("hh:mm A")} - {item.date_end ? moment(item.date_end).format("hh:mm A") : "ongoing"} ({handleDisplayDuration(item.duration_in_seconds)})</td>
                                                        <td title={item.url} className={'display-url'}>{item.url}</td>
                                                        <td className={'text-center'}>{moment(item.created_at).format("MMM-DD-YYYY")}</td>
                                                        <td className={'text-center'}>
                                                            <Button
                                                                className=' p-1 pt-0 pb-0'
                                                                style={{ fontSize: '12px', color: 'white' }}
                                                                variant=' btn-transparent'
                                                                size='sm'
                                                                title={"Screenshots"}
                                                                onClick={() => {
                                                                    setScreenshots(item.screenshots)
                                                                    setDetails({
                                                                        userAccount: item.username,
                                                                        pcName: item.pc_name,
                                                                        alarm: item.name
                                                                    })
                                                                    setShowScreenshotPage(true)
                                                                }}
                                                            >
                                                                <View/>
                                                            </Button>
                                                            {/*<Button*/}
                                                            {/*    className=' p-1 pt-0 pb-0'*/}
                                                            {/*    style={{ fontSize: '12px', color: 'white' }}*/}
                                                            {/*    variant=' btn-transparent'*/}
                                                            {/*    size='sm'*/}
                                                            {/*>*/}
                                                            {/*    <Delete/>*/}
                                                            {/*</Button>*/}
                                                        </td>
                                                    </tr>
                                                )
                                            ) : (
                                                <tr className='no-item'>
                                                    <td colSpan={8}>{TEXT.NOT_FOUND}</td>
                                                </tr>
                                            )}
                                        </>
                                        </tbody>
                                    </Table>

                                    <Pagination
                                        itemsCount={itemsCount}
                                        itemsPerPage={itemsPerPage}
                                        currentPage={currentPage}
                                        lastPage={lastPage}
                                        setCurrentPage={setCurrentPage}
                                        alwaysShown={false}
                                        pageClicked={(page: number) => {
                                            getAlarmLog(page, searched, entries, filter.date_from, filter.date_to, filter.filter);
                                        }
                                        }
                                    />
                                </>
                                : <AlarmLogScreenshots screenshots={screenshots} onBack={() => setShowScreenshotPage(false)} userAccount={details.userAccount} pcName={details.pcName} alarm={details.alarm}/>
                        }

                    </Card.Body>
                </Card>
                {/*<Dialog*/}
                {/*    show={showConfirm}*/}
                {/*    setShow={handleCloseConfirm}*/}
                {/*    setEvent={() => {*/}
                {/*        deleteAllowance(item.allowance_id)*/}
                {/*    }*/}
                {/*    }*/}
                {/*/>*/}

                <Loader show={showLoading}/>

                {/*/!* Screenshots MODAL*!/*/}

                {/*<Modal className='modal modal-lg' centered show={showScreenshots} onHide={handleCloseScreenshots}>*/}
                {/*    <Modal.Header closeButton>*/}
                {/*        <Modal.Title className='fw-bold'>Alarm Screenshots</Modal.Title>*/}
                {/*    </Modal.Header>*/}
                {/*    <Modal.Body>*/}
                {/*        <Form>*/}
                {/*            <Row>*/}
                {/*                {screenshots.map((screenshot, index) => (*/}
                {/*                        // <Form.Group as={Col} key={index} md="4" >*/}
                {/*                        //     <a href={IMAGE_BASE_URL + screenshot.screenshot} target="_blank" className="photo-a" rel="noreferrer">*/}
                {/*                        //         <div className="card">*/}
                {/*                        //             <img style={{height: "150px", width: "auto", objectFit: "cover"}} className="card-img-top" alt={"Captured Screenshot"} src={IMAGE_BASE_URL + screenshot.screenshot}/>*/}
                {/*                        //         </div>*/}
                {/*                        //     </a>*/}
                {/*                        // </Form.Group>*/}
                {/*                    <Col key={index} md={3} className="mb-3">*/}
                {/*                        <a href={IMAGE_BASE_URL + screenshot.screenshot} target="_blank" className="photo-a" rel="noreferrer">*/}
                {/*                            <Card className="h-100">*/}
                {/*                                <Card.Img variant="top" src={IMAGE_BASE_URL + screenshot.screenshot} style={{ height: "150px", objectFit: "cover" }} />*/}
                {/*                                <Card.Body className="p-2" style={{ fontSize: '90%' }}>*/}
                {/*                                    <small className="text-muted">*/}
                {/*                                        {moment(screenshot.created_at).format("hh:mm A")}*/}
                {/*                                    </small>*/}
                {/*                                </Card.Body>*/}
                {/*                            </Card>*/}
                {/*                        </a>*/}
                {/*                    </Col>*/}

                {/*                ))}*/}
                {/*            </Row>*/}
                {/*        </Form>*/}
                {/*    </Modal.Body>*/}
                {/*    <Modal.Footer>*/}
                {/*        <Button variant='outline-primary' size={'sm'} onClick={handleCloseScreenshots}>*/}
                {/*            Close*/}
                {/*        </Button>*/}
                {/*    </Modal.Footer>*/}
                {/*</Modal>*/}
                <br />
            </Container>
        </>
    )
}
